// extracted by mini-css-extract-plugin
module.exports = {"root":"DhlmaYoe","flexColumn":"lP4D0xJo","titleLabel":"uVAdLvqx","tickerLabel":"_6mI0xM6X"};